/* The registry pages' small enhancements (the pages work without them):
   the index's live text filter and "+N more" tags toggle, the entry page's
   copy-badge button, and the two forms' character counter, "Other" category
   field, removal placeholder, client-side length check and busy state. */
(function () {
  'use strict'

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn)
  }

  /* -- index: text filter ------------------------------------------------ */
  function initIndex(root) {
    var input = root.querySelector('[data-registry-filter]')
    var list = root.querySelector('[data-registry-list]')
    var count = root.querySelector('[data-registry-count]')
    var empty = root.querySelector('[data-registry-empty]')
    var emptyText = root.querySelector('[data-registry-empty-text]')
    var clear = root.querySelector('[data-registry-clear]')
    var faceted = !!(clear && !clear.hidden && !(input && input.value.trim()))
    if (input && list) {
      var form = input.form
      if (form) form.addEventListener('submit', function (e) { e.preventDefault() })
      var apply = function () {
        var q = input.value.trim().toLowerCase()
        var shown = 0
        each(list, 'li[data-haystack]', function (li) {
          var hit = !q || li.getAttribute('data-haystack').indexOf(q) !== -1
          li.hidden = !hit
          if (hit) shown++
        })
        list.hidden = shown === 0
        if (count) {
          count.hidden = shown === 0
          count.textContent = shown === 1 ? '1 project' : shown + ' projects'
        }
        if (empty) empty.hidden = shown !== 0
        if (emptyText) {
          var raw = input.value.trim()
          emptyText.textContent = raw
            ? emptyText.getAttribute('data-text-query').replace('%s', raw)
            : emptyText.getAttribute('data-text') + '.'
        }
        if (clear) clear.hidden = !(faceted || q)
      }
      input.addEventListener('input', apply)
      if (clear) {
        clear.addEventListener('click', function () { input.value = '' })
      }
    }
    var more = root.querySelector('[data-tag-more]')
    if (more) {
      more.addEventListener('click', function () {
        var open = more.getAttribute('aria-expanded') !== 'true'
        each(root, '[data-tag-extra]', function (el) { el.hidden = !open })
        more.setAttribute('aria-expanded', open ? 'true' : 'false')
        more.textContent = more.getAttribute(open ? 'data-label-fewer' : 'data-label-more')
      })
    }
  }

  /* -- entry: copy the badge markdown ------------------------------------ */
  function initCopy(btn) {
    var source = document.querySelector('[data-copy-source]')
    if (!source || !navigator.clipboard) return
    var label = btn.textContent
    var timer = 0
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(source.textContent).then(
        function () {
          btn.textContent = btn.getAttribute('data-label-copied')
          clearTimeout(timer)
          timer = setTimeout(function () { btn.textContent = label }, 2000)
        },
        function (err) {
          // The snippet stays selectable by hand.
          console.warn('[registry] clipboard write failed:', err)
        }
      )
    })
  }

  /* -- forms ---------------------------------------------------------------- */
  function initForm(form) {
    var error = form.parentNode.querySelector('[data-form-error]')
    var minField = form.elements[form.getAttribute('data-min-field')]
    var min = Number(form.getAttribute('data-min')) || 0

    each(form, '[data-count-max]', function (area) {
      var left = area.parentNode.querySelector('[data-count-left]')
      var max = Number(area.getAttribute('data-count-max'))
      var update = function () {
        if (left) left.textContent = area.value.length ? ' ' + (max - area.value.length) + ' left.' : ''
      }
      area.addEventListener('input', update)
    })

    var select = form.querySelector('[data-category-select]')
    var other = form.querySelector('[data-category-other]')
    if (select && other) {
      select.addEventListener('change', function () { other.hidden = select.value !== 'other' })
    }

    var message = form.querySelector('[data-placeholder-removal]')
    if (message) {
      each(form, 'input[name="kind"]', function (radio) {
        radio.addEventListener('change', function () {
          var kind = form.querySelector('input[name="kind"]:checked')
          message.placeholder = message.getAttribute(
            kind && kind.value === 'removal' ? 'data-placeholder-removal' : 'data-placeholder-change'
          )
        })
      })
    }

    form.addEventListener('submit', function (e) {
      if (minField && minField.value.trim().length < min) {
        e.preventDefault()
        if (error) {
          error.textContent = form.getAttribute('data-min-error')
          error.hidden = false
        }
        return
      }
      var send = form.querySelector('button[type="submit"]')
      var spinner = form.querySelector('[data-spinner]')
      if (send) send.disabled = true
      if (spinner) spinner.hidden = false
    })
  }

  function init() {
    each(document, '[data-registry-index]', initIndex)
    each(document, '[data-copy]', initCopy)
    each(document, 'form[data-registry-form]', initForm)
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()
})()
